export default __webpack_public_path__ + "static/media/followWhite.f6246d06.svg";